/* eslint-disable no-console */
<template>
  <v-container>
    <div class="Text Generator">
      <v-container fill-height style="gap: 1rem">
        <v-card style="width: 100%">
          <v-card-title>
            Text Generator
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-textarea
              clearable
              clear-icon="mdi-close-circle"
              label="Texteingabe"
              counter
              no-resize
              :disabled="loading"
              v-model="prompt"
            ></v-textarea>
            <v-btn color="green" :disabled="loading" @click="submit"
              >Text erstellen</v-btn
            >
          </v-card-text>
        </v-card>

        <v-card style="width: 100%">
          <v-card-title>Resultat</v-card-title>
          <v-card-text>
            <v-progress-circular
              :size="70"
              :width="7"
              color="green"
              indeterminate
              v-if="loading"
            ></v-progress-circular>
            {{ result }}
            <p v-if="!loading">{{ result }}</p>
          </v-card-text>
        </v-card>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { Configuration, OpenAIApi } from 'openai';

export default {
  data() {
    return {
      prompt: '',
      loading: false,
      result: '',
    };
  },
  created() {},
  mounted() {},

  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },

  methods: {
    async submit() {
      if (!this.prompt) {
        console.log('Empty');
        return false;
      }
      this.result = (await this.generateText()) || 0;
      if (this.result) {
        this.loading = false;
      }
      return true;
    },

    async generateText() {
      try {
        this.loading = true;
        const configuration = new Configuration({
          apiKey: process.env.VUE_APP_OPEN_AI,
        });
        const openai = new OpenAIApi(configuration);
        const t = this;

        return await openai.createCompletion({
          model: 'text-davinci-003',
          prompt: t.prompt,
        });
      } catch (error) {
        console.error(error);
        return false;
      }
    },
  },
};
</script>
